import { render } from "./AutomationWizardFieldPriorityIconButton.vue?vue&type=template&id=6700cef1&scoped=true"
import script from "./AutomationWizardFieldPriorityIconButton.vue?vue&type=script&lang=js"
export * from "./AutomationWizardFieldPriorityIconButton.vue?vue&type=script&lang=js"

import "./AutomationWizardFieldPriorityIconButton.vue?vue&type=style&index=0&id=6700cef1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6700cef1"]])

export default __exports__